"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.annotationCanvasStyleDefault = void 0;
var utils_1 = require("../../utils");
var bbox_style_1 = require("../types/record/bbox-style");
var paint_style_1 = require("../types/record/paint-style");
exports.annotationCanvasStyleDefault = {
    root: {
        width: '100%',
        height: '100%'
    },
    background: 'checkerboard',
    bgMinPaddingPx: 10,
    bbox: (0, bbox_style_1.IBboxStyle)(),
    paint: (0, paint_style_1.IPaintStyle)(),
    crosshairLineColor: 'gray',
    crosshairLineWidthPx: 1,
    temporaryRectBorderWidthPx: 1,
    temporaryRectBorderColor: (0, utils_1.rgbToStr)([130, 125, 175]),
    temporaryRectBackgroundColor: (0, utils_1.rgbaToStr)([130, 125, 175, 0.5]),
    labelSaturation: 80,
    labelLightness: 50
};
